import React from "react";
import buildHeroImageUrls from "utils/buildHeroImageUrls";

const BrandModelHeroImage = ({
  imagePath,
  heroImagePosition,
  heroImageWithBackground,
  heroImageFullCover,
  altText = "Automodell",
  classNames,
}) => (
  <picture
    className={`relative h-full ${
      heroImageWithBackground
        ? ""
        : `flex items-center justify-center xl:justify-${heroImagePosition
            || "end"} ultra-wide:justify-center`
    } ${classNames ? classNames.join(" ") : ""}`}
  >
    <source
      srcSet={buildHeroImageUrls(imagePath, 2560)}
      media="(min-width: 2560px)"
      width="2560"
      height="1440"
    />
    <source
      srcSet={buildHeroImageUrls(imagePath, 1920)}
      media="(min-width: 1920px)"
      width="1920"
      height="1080"
    />
    <source
      srcSet={buildHeroImageUrls(imagePath, 1680)}
      media="(min-width: 1680px)"
      width="1680"
      height="945"
    />
    <source
      srcSet={buildHeroImageUrls(imagePath, 1280)}
      media="(min-width: 1200px)"
      width="1280"
      height="720"
    />
    <source
      srcSet={buildHeroImageUrls(imagePath, 768)}
      media="(min-width: 768px)"
      width="768"
      heigh="432"
    />
    {/* <source
      srcSet={buildHeroImageUrls(imagePath, 480)}
      media="(min-width: 480px)"
    /> */}
    <source
      srcSet={buildHeroImageUrls(imagePath, 375)}
      width="375"
      height="211"
    />

    <img
      className={`block h-full ${
        heroImageWithBackground || heroImageFullCover
          ? "object-cover w-full"
          : "object-contain"
      }`}
      src={buildHeroImageUrls(imagePath, 768, false)}
      height="432"
      width="768"
      alt={altText}
    />
  </picture>
);

export default BrandModelHeroImage;
